/* eslint-disable react/button-has-type */
import React from 'react';

import Img from '../../Img';

import styles from './upgrade.scss';

const PowerEventUpgrade = props => {
    const { 'data-testid': dataTestId } = props;
    const handleClick = (ev) => {
        ev.preventDefault();
        props.onClick(ev);
    };

    return (
        <div className={`${styles.section}`} data-testid={dataTestId}>
            <div className={`${styles.titleSection}`}>
                <div className={`${styles.title}`} data-testid={dataTestId && `${dataTestId}.title`}>This event is available<br /> exclusively for Power members</div>
            </div>
            <div>
                <div className={`${styles.listIntro}`} data-testid={dataTestId && `${dataTestId}.intro`}>With a power subscription you can:</div>
                <div>
                    <div className={`d-flex flex-row ${styles.listItem}`}>
                        <div>
                            <Img src="/img/icons/checkmark-teal.svg" />
                        </div>
                        <div data-testid={dataTestId && `${dataTestId}.feature-verified-events`}>
                            Register for unlimited Verified events at a discount
                        </div>
                    </div>
                    <div className={`d-flex flex-row ${styles.listItem}`}>
                        <div>
                            <Img src="/img/icons/checkmark-teal.svg" />
                        </div>
                        <div data-testid={dataTestId && `${dataTestId}.feature-connect`}>
                            Connect with <span>anyone</span> in the UTR Sports community for more play
                        </div>
                    </div>
                    <div className={`d-flex flex-row ${styles.listItem}`}>
                        <div>
                            <Img src="/img/icons/checkmark-teal.svg" />
                        </div>
                        <div data-testid={dataTestId && `${dataTestId}.feature-personal-club`}>
                            Create a personal club for up to 25 tennis friends
                        </div>
                    </div>
                    <div className={`d-flex flex-row ${styles.listItem}`}>
                        <div>
                            <Img src="/img/icons/checkmark-teal.svg" />
                        </div>
                        <div data-testid={dataTestId && `${dataTestId}.feature-college-tools`}>
                            Access college research tools
                        </div>
                    </div>
                    <div className={`d-flex flex-row ${styles.listItem}`}>
                        <div>
                            <Img src="/img/icons/checkmark-teal.svg" />
                        </div>
                        <div data-testid={dataTestId && `${dataTestId}.feature-rating-history`}>
                            Access advanced rating history
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className={`d-flex flex-row ${styles.buttonArea}`}>
                    <div>
                        <button className={`btn btn-primary btn-xl text-uppercase font-weight-normal`} onClick={handleClick} data-testid={dataTestId && `${dataTestId}.upgrade-btn`}>Upgrade Now</button>
                    </div>
                    <div className={`${styles.pricingText}`}>
                        <span className={`${styles.currency}`}>$</span>120<span className={`${styles.period}`}>/yr</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PowerEventUpgrade;
